import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Header from 'components/Header';
import Footer from 'components/Footer';
import Helmet from 'components/Helmet';
import MainLayout from 'layouts/MainLayout';
import { styled } from '@mui/system';
import { getLayout } from 'actions/layouts';
import RenderPageSchema from 'components/RenderPageSchema';
import Preloader from 'components/Preloader';

const ContentWrapper = styled('section')(({ theme }) => ({
  padding: '60px 100px',
  maxWidth: 800,
  margin: '0 auto',
  boxSizing: 'content-box',
  [theme.breakpoints.down('lg')]: {
    padding: 50
  },
  [theme.breakpoints.down('md')]: {
    padding: 30,
    paddingTop: 60,
    paddingBottom: 40
  },
  [theme.breakpoints.down('sm')]: {
    padding: 20,
    paddingTop: 60,
    paddingBottom: 40
  }
}));

const StaticPage = ({ category, name }) => {
  const [layout, setLayout] = React.useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const layoutData = useSelector((state) => state.pages.state[name]);

  React.useEffect(() => {
    const fetchData = async () => {
      // suppressErrors → getLayout resolves null on 404 instead of re-throwing
      // (which previously became an unhandled rejection + a forever-spinner).
      const result = await dispatch(getLayout(category, name, true));
      if (!result) {
        navigate('/404', { replace: true });
        return;
      }
      setLayout(result);
    };
    if (layoutData) {
      setLayout(layoutData);
      return;
    }
    fetchData();
  }, [dispatch, layoutData, category, name, navigate]);

  if (!layout) {
    return <Preloader />;
  }

  return (
    <>
      <Helmet meta={layout?.meta} />
      <MainLayout>
        <Header />
        <ContentWrapper>
          <RenderPageSchema schema={layout} />
        </ContentWrapper>
        <Footer />
      </MainLayout>
    </>
  );
};

export default StaticPage;
